/** A COUNT AS A PERSON READS IT (ported 2026-10-18 from the medrec console's four reviews, its PR #177, A7: "9999 open"): grouped,
 *  "9,999", on every tab, chip, heading, tile and total. A number that is not a count (a goal, a day, a percent) stays as it is. */
export const countOf = (n: number): string => n.toLocaleString('en-US');

/** THE RAIL'S BADGE (A7: a four-digit badge ran past the rail's edge and was cut): past 999 it reads "999+" in a wide badge set against the
 *  rail's edge; the item's hover keeps the whole count, grouped. */
export const BADGE_MAX = 999;
export const badgeOf = (n: number): string => (n > BADGE_MAX ? `${BADGE_MAX}+` : String(n));
